
import React, { useState } from 'react';
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogTrigger,
  DialogDescription
} from "./ui/dialog";
import { Button } from "./ui/button";
import { Input } from "./ui/input";
import { Textarea } from "./ui/textarea";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectTrigger,
  SelectValue,
} from "./ui/select";
import { locations } from '../data/mockData';
import { sendWholesaleEmail } from '../config/smtpConfig';
import { toast } from "sonner";
import { MessageCircleQuestion } from 'lucide-react';

const SacModal = () => {
  const [open, setOpen] = useState(false);
  const [loading, setLoading] = useState(false);
  const [formData, setFormData] = useState({
    nome: '',
    telefone: '',
    email: '',
    loja: '',
    retorno: '',
    mensagem: ''
  });

  const handleChange = (e) => {
    setFormData({ ...formData, [e.target.name]: e.target.value });
  };

  const handleSelectChange = (value) => {
      setFormData({ ...formData, loja: value });
  }

  const handleReturnChange = (value) => {
      setFormData({ ...formData, retorno: value });
  }

  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    try {
        await sendWholesaleEmail({ ...formData, type: 'SAC' });
        toast.success("Mensagem enviada com sucesso! Entraremos em contato em breve.");
        setOpen(false);
        setFormData({ nome: '', telefone: '', email: '', loja: '', retorno: '', mensagem: '' });
    } catch (error) {
        toast.error("Erro ao enviar mensagem.");
    } finally {
        setLoading(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={setOpen}>
      <DialogTrigger asChild>
        <Button 
            variant="ghost" 
            className="text-white hover:text-[#FFC300] font-bold uppercase tracking-widest text-sm transition-colors hover:bg-white/10 gap-2"
        >
            <MessageCircleQuestion className="w-5 h-5" />
            SAC
        </Button>
      </DialogTrigger>
      <DialogContent className="sm:max-w-[500px] bg-white text-gray-900 border-[#E63312]">
        <DialogHeader>
          <DialogTitle className="text-2xl font-black text-[#E63312] uppercase">Fale Conosco (SAC)</DialogTitle>
          <DialogDescription>
            Preencha o formulário abaixo para enviar sua dúvida, sugestão ou reclamação.
          </DialogDescription>
        </DialogHeader>
        
        <form onSubmit={handleSubmit} className="space-y-4 mt-4">
            <div className="space-y-2">
                <label className="text-sm font-bold text-gray-700">Nome*</label>
                <Input 
                    name="nome"
                    value={formData.nome}
                    onChange={handleChange}
                    required 
                    className="bg-gray-50 focus:border-[#E63312]"
                />
            </div>
            
            <div className="grid grid-cols-2 gap-4">
                <div className="space-y-2">
                    <label className="text-sm font-bold text-gray-700">Telefone*</label>
                    <Input 
                        name="telefone"
                        value={formData.telefone}
                        onChange={handleChange}
                        required 
                        placeholder="(00) 00000-0000"
                        className="bg-gray-50 focus:border-[#E63312]"
                    />
                </div>
                <div className="space-y-2">
                    <label className="text-sm font-bold text-gray-700">E-mail*</label>
                    <Input 
                        name="email"
                        type="email"
                        value={formData.email}
                        onChange={handleChange}
                        required 
                        className="bg-gray-50 focus:border-[#E63312]"
                    />
                </div>
            </div>

            <div className="space-y-2">
                <label className="text-sm font-bold text-gray-700">Meio de Retorno*</label>
                <Select onValueChange={handleReturnChange} required>
                    <SelectTrigger className="bg-gray-50 focus:border-[#E63312]">
                        <SelectValue placeholder="Como prefere nosso contato?" />
                    </SelectTrigger>
                    <SelectContent>
                        <SelectItem value="Email">E-mail</SelectItem>
                        <SelectItem value="Whatsapp">WhatsApp</SelectItem>
                    </SelectContent>
                </Select>
            </div>

            <div className="space-y-2">
                <label className="text-sm font-bold text-gray-700">Selecione a Loja*</label>
                <Select onValueChange={handleSelectChange} required>
                    <SelectTrigger className="bg-gray-50 focus:border-[#E63312]">
                        <SelectValue placeholder="Escolha uma unidade" />
                    </SelectTrigger>
                    <SelectContent>
                        {locations.map((loc) => (
                            <SelectItem key={loc.id} value={loc.name}>
                                {loc.name} - {loc.city}
                            </SelectItem>
                        ))}
                        <SelectItem value="Geral">Assunto Geral / Outros</SelectItem>
                    </SelectContent>
                </Select>
            </div>

            <div className="space-y-2">
                <label className="text-sm font-bold text-gray-700">Mensagem*</label>
                <Textarea 
                    name="mensagem"
                    value={formData.mensagem}
                    onChange={handleChange}
                    required 
                    className="min-h-[100px] bg-gray-50 focus:border-[#E63312]"
                />
            </div>

            <Button 
                type="submit" 
                disabled={loading}
                className="w-full bg-[#E63312] hover:bg-black text-white hover:text-[#FFC300] font-bold h-12 uppercase tracking-widest mt-2"
            >
                {loading ? "Enviando..." : "Enviar Mensagem"}
            </Button>
        </form>
      </DialogContent>
    </Dialog>
  );
};

export default SacModal;
